import Phaser from 'phaser';
import { floodFill } from '../Utils';

export default class FloodFillContainer {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image[]} imagesArray 
   * @param {*} x 
   * @param {*} y 
   * @param {string} color 
   * @returns 
   */
  floodFill (imagesArray, x, y, color, width, height) {
    const colorSubstring = color.substring(1, 7);
    const updatedColorNumber = Number(`0xFF${colorSubstring}`);

    const floodFillCanvas = this.scene.textures.createCanvas(Phaser.Utils.String.UUID(),width,height);
    const ctx = floodFillCanvas.context;
    imagesArray.forEach((image) => {
      ctx.drawImage(this.scene.textures.get(image.texture.key).canvas, 0,0);
    });
    floodFill(x, y, updatedColorNumber, ctx);
    floodFillCanvas.refresh();
    return new Phaser.GameObjects.Image(this.scene, 0,0,floodFillCanvas.key);
  }
}